export * from './angular-material.module';
